<template>
  <transition name="fade">
    <div class="modal modal-default">
      <div class="modal__overlay" @click="$emit('close')"></div>
      <div class="small-modal">
        <div class="small-modal__close" @click="$emit('close')">X</div>
        <div class="small-modal__head">
          <span>Generation PDF</span>
        </div>

        <div class="small-modal__body">
          <template v-if="!isPdfCreated">
            <p class="text-center">PDF generating... </p>
            <Preloader />
          </template>
          <template v-else>
            <p>PDF file ready for download</p>
          </template>

        </div>

        <div class="small-modal__footer">
          <div class="small-modal__footer__actions d-flex justify-content-between">
            <button class="blue-button" @click="$emit('close')">
              <span>Close</span>
            </button>
            <button class="orange-button" :disabled="!isPdfCreated" @click="redirectForDownloading">
              <span>Download</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

  import Preloader from '@/components/Preloader'

  export default {
    name: 'PdfModal',
    components: {
      Preloader
    },
    props: {
      quote: Object,
      isShown: Boolean,
    },
    data() {
      return {
        isPdfCreated:false,
      }
    },
    computed: {
      getDownloadLink() {
        return this.getApiAuthUrl('garantie/generate-pdf/' + this.quote.id);
      },
    },
    watch: {
      'isShown' : function() {
        // TODO refreshing token
        if (this.isShown && this.quote && this.quote.id) {
            this.isPdfCreated = true;
          //this.getPdfDownloadLink();
        }
      }
    },
    methods: {
      redirectForDownloading() {
        window.location = this.getDownloadLink;

        this.$emit('close');
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/PdfModal.vue